module.exports = __webpack_public_path__ + "img/spazi_1.28248f39.webp";